import {Binding, Directive, inject, input, OnInit, Type, ViewContainerRef} from '@angular/core';

export type StepBody = {
    render: Type<unknown>;
    bindings: ReadonlyArray<Binding>;
};

@Directive({
    selector: '[appStepOutlet]',
    standalone: true,
})
export class StepOutletDirective implements OnInit {
    private readonly viewContainerRef = inject(ViewContainerRef);

    readonly body = input.required<StepBody>({alias: 'appStepOutlet'});

    ngOnInit(): void {
        const {render, bindings} = this.body();
        this.viewContainerRef.createComponent(render, {bindings: [...bindings]});
    }
}
